let EVENT_TYPES = {
  APPOINTMENT_BOOKING_STATE_UPDATE: 'AppointmentBookingStateUpdate',
  CONTRACT_SIGNED: 'ContractSigned',
  DOCUMENT_SIGNED: 'DocumentSigned',
  LEAD_STATUS_CHANGED: 'LeadStatusChanged',
  MEDICAL_FORM_SUBMITTED: 'MedicalFormSubmitted',
  RESOURCE_INSERT: 'ResourceInsert',
  TREATMENT_STATUS_UPDATE: 'TreatmentStatusUpdate',
}

export function getView(event_type) {
  return EVENT_TYPES[event_type] || 'No'
}
